import type { BimContractSeasonInflationInput } from 'gql/graphql';
import { requiredBaseRule } from 'utils/constants';
import { getEditableNumberCell } from 'utils/tableCells';

import { useMemo } from 'react';
import type { Control } from 'react-hook-form';

export interface IUseSeasonsInflationColumns {
    isEditable?: boolean;
    control?: Control;
}

export type TBimContractSeasonInflationInputRow = BimContractSeasonInflationInput & { id: string };

export const getInflationRateKey = (row: TBimContractSeasonInflationInputRow) =>
    `inflationRate_${row.contractSeasonYear}`;

export const useBimSeasonsInflationColumns = (props?: IUseSeasonsInflationColumns) => {
    const { isEditable, control } = props || {};

    return useMemo(
        () => [
            {
                title: 'Сезон',
                accessor: 'contractSeasonYear',
                width: 337,
                renderCell: (row: TBimContractSeasonInflationInputRow) => row.contractSeasonYear,
            },
            getEditableNumberCell({
                title: 'Коэффициент инфляции',
                accessor: 'inflationRate',
                nameGetter: getInflationRateKey,
                isEditable,
                control,
                doNotCheckRowFlag: true,
                width: 337,
                textFieldWidth: 'full',
                decimalScale: 4,
                rules: requiredBaseRule,
                isTooltipHidden: true,
                placeholder: '0',
                texRight: true,
            }),
        ],
        [control, isEditable],
    );
};
